import Vue from 'vue'
import { GST_INIT_LOADING, GST_INIT_SUCCESS, GST_INIT_FAIL, GSTMAP_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  gstMap: {
    gstMapKey: {
      gstApplnInt: null,
      sepStatCtyRisk: null,
      sepStatBrn: null,
      sepStatDri: null,
      sepStatRegStat: null,
      sepStatCtyAgt: null,
      sepStatCtyCed: null,
      sepStatCtyRi: null
    }
  }
}

const getters = {
  gstMapKey(state) {
    return state.gstMap.gstMapKey
  }
}

const mutations = {
  [GST_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [GST_INIT_SUCCESS](state, data) {
    state.init = 1
    Vue.set(state, 'menu', data.menu)
    state.initErr = []
  },
  [GST_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [GSTMAP_COMMIT_KEY](state, data) {
    state.gstMap.gstMapKey.gstApplnInt = data.gstApplnInt
    state.gstMap.gstMapKey.sepStatCtyRisk = data.sepStatCtyRisk
    state.gstMap.gstMapKey.sepStatBrn = data.sepStatBrn
    state.gstMap.gstMapKey.sepStatDri = data.sepStatDri
    state.gstMap.gstMapKey.sepStatRegStat = data.sepStatRegStat
    state.gstMap.gstMapKey.sepStatCtyAgt = data.sepStatCtyAgt
    state.gstMap.gstMapKey.sepStatCtyCed = data.sepStatCtyCed
    state.gstMap.gstMapKey.sepStatCtyRi = data.sepStatCtyRi
    const commit = {
      gstApplnInt: data.gstApplnInt,
      sepStatCtyRisk: data.sepStatCtyRisk,
      sepStatBrn: data.sepStatBrn,
      sepStatDri: data.sepStatDri,
      sepStatRegStat: data.sepStatRegStat,
      sepStatCtyAgt: data.sepStatCtyAgt,
      sepStatCtyCed: data.sepStatCtyCed,
      sepStatCtyRi: data.sepStatCtyRi
    }
    sessionStorage.setItem('gstMap', JSON.stringify(commit))
  }
}

const actions = {
  async gstManagementInit({ commit, dispatch, rootState }) {
    const apiUrl = rootState.app.menu.gstManagement
    commit(GST_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(GST_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(GST_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
